import { render, staticRenderFns } from "./MarketplaceReviewsFilter.vue?vue&type=template&id=a506f7f0&scoped=true"
import script from "./MarketplaceReviewsFilter.vue?vue&type=script&lang=js"
export * from "./MarketplaceReviewsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a506f7f0",
  null
  
)

export default component.exports